import { makeStyles } from "@material-ui/core/styles";
import styles from "standard.module.scss";

import { useHistory } from "react-router-dom";

import { linkToNewPhoto } from "../../routes/photo/routes/new/links";
import { linkToRecordWaterTestResults } from "../../routes/record/links";
import { linkToRecordIncident } from "../../routes/record/links";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import PageWrapper from "../../components/PageWrapper";
import config, { linkToMap } from "custom/config";

import { useUser } from "../../providers/UserProvider";
import { useSurveys } from "../../providers/SurveysProvider";
import { linkToLoginWithRedirectOnSuccess } from "routes/login/links";
import { linkToSurveyPage } from "routes/surveys/links";
import { Survey } from "types/Survey";

import litterImage from "../../assets/images/record/litter.webp";
import waterQualityImage from "../../assets/images/record/water-quality.png";
import waterPollutionIncidentImage from "../../assets/images/record/water-pollution-incident.webp";
import waterWatchSurveyImage from "../../assets/images/record/water-watch-survey.webp";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(2),
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: theme.spacing(2.4, 1.2),
    marginBlock: theme.spacing(2),
    height: "100%",
    "@media (max-width: 375px)": {
      marginBlock: theme.spacing(1)
    }
  },
  subheadings: {
    color: "#0E2E3A",
    textAlign: "center",
    lineHeight: 1.3,
    textWrap: "balance",
    fontSize: "1.25rem",
    "@media (max-width: 390px)": {
      fontSize: "1rem"
    }
  },
  buttonCard: {
    width: "100%",
    cursor: "pointer",
    borderRadius: theme.spacing(0.5),
    boxShadow: styles.boxShadowSoftElevation
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 375px)": {
      padding: theme.spacing(1)
    }
  },
  cardDescription: {
    marginTop: theme.spacing(1)
  },
  image: {
    width: "100%",
    height: "60%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    [theme.breakpoints.up("lg")]: {
      maxWidth: 320,
      marginInline: "auto"
    }
  }
}));

const RecordPollutionHome = () => {
  const classes = useStyles();
  const history = useHistory();
  const handleClose = () => history.push(linkToMap());

  const { user } = useUser();

  const handleLaunchSurvey = (surveyId: string) => {
    if (config.SECURITY.UPLOAD_REQUIRES_LOGIN && !user) {
      history.push(
        linkToLoginWithRedirectOnSuccess(linkToSurveyPage(surveyId))
      );
    } else {
      history.push(linkToSurveyPage(surveyId));
    }
  };

  const surveysData = useSurveys();
  const surveys = surveysData?.surveys || undefined;
  const now = new Date();
  const activeSurveys = surveys
    ? surveys.filter((survey: Survey) => {
        if (survey.permanent) return true;
        const startDateTime = new Date(survey.fromDate);
        const endDateTime = new Date(survey.toDate);
        return now >= startDateTime && now <= endDateTime;
      })
    : [];

  return (
    <PageWrapper
      label={"Record"}
      navigationHandler={{ handleClose: handleClose }}
    >
      <div className={classes.wrapper}>
        <Card
          className={classes.buttonCard}
          variant="outlined"
          onClick={() => history.push(linkToNewPhoto())}
          role="button"
          tabIndex={0}
        >
          <div
            className={classes.image}
            style={{ backgroundImage: `url(${litterImage})` }}
          />
          <CardContent className={classes.cardContent}>
            <Typography
              variant="h6"
              component="h1"
              color="primary"
              className={classes.subheadings}
            >
              Record litter
            </Typography>
          </CardContent>
        </Card>
        <Card
          className={classes.buttonCard}
          variant="outlined"
          onClick={() => history.push(linkToRecordWaterTestResults())}
          role="button"
          tabIndex={0}
        >
          <div
            className={classes.image}
            style={{ backgroundImage: `url(${waterQualityImage})` }}
          />
          <CardContent className={classes.cardContent}>
            <Typography
              variant="h6"
              component="h1"
              color="primary"
              className={classes.subheadings}
            >
              Record a water test
            </Typography>
          </CardContent>
        </Card>
        <Card
          className={classes.buttonCard}
          variant="outlined"
          onClick={() => history.push(linkToRecordIncident())}
          role="button"
          tabIndex={0}
        >
          <div
            className={classes.image}
            style={{ backgroundImage: `url(${waterPollutionIncidentImage})` }}
          />
          <CardContent className={classes.cardContent}>
            <Typography
              variant="h6"
              component="h1"
              color="primary"
              className={classes.subheadings}
            >
              Report a pollution incident
            </Typography>
          </CardContent>
        </Card>
        <Card
          className={classes.buttonCard}
          variant="outlined"
          onClick={() => {
            if (activeSurveys.length > 0) {
              handleLaunchSurvey(activeSurveys[0].id);
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div
            className={classes.image}
            style={{ backgroundImage: `url(${waterWatchSurveyImage})` }}
          />
          <CardContent className={classes.cardContent}>
            <Typography
              variant="h6"
              component="h1"
              color="primary"
              className={classes.subheadings}
            >
              Conduct a visual survey
            </Typography>
            {/* TODO: check the below requirement */}
            {/* {activeSurveys.length > 0 ? (
              <Typography
                variant="body1"
                component="p"
                color="primary"
                className={classes.cardDescription}
              >
                {`Join ${activeSurveys[0].name}`}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                className={classes.cardDescription}
              >
                No current surveys to display
              </Typography>
            )} */}
          </CardContent>
        </Card>
      </div>
    </PageWrapper>
  );
};

export default RecordPollutionHome;
